import React from 'react';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/tspc-banner.png';
import laserMicrometer from '../../assets/images/qa/carousel/laser-micrometer.png';
import dialTestIndicator from '../../assets/images/qa/carousel/dial-test-indicator.png';
import profileProjector from '../../assets/images/qa/carousel/profile-projector.png';
import digitalMicrometer from '../../assets/images/qa/carousel/digital-micrometer.png';
import skyViewer from '../../assets/images/qa/carousel/sky-viewer.png';
import roundnessDiagram from '../../assets/images/qa/machines/roundness-diagram.png';
import roundnessPhoto from '../../assets/images/qa/machines/roundness-photo.jpg';
import hardnessDiagram from '../../assets/images/qa/machines/hardness-diagram.png';
import hardnessPhoto from '../../assets/images/qa/machines/hardness-photo.jpg';
import surfaceDiagram from '../../assets/images/qa/machines/surface-texture-diagram.png';
import surfacePhoto from '../../assets/images/qa/machines/surface-texture-photo.jpg';
import keyenceDiagram from '../../assets/images/qa/machines/keyence-diagram.png';
import keyencePhoto from '../../assets/images/qa/machines/keyence-photo.jpg';
import './QualityAssurance.css';

const instruments = [
  { img: laserMicrometer, name: 'Laser Micrometer Machine' },
  { img: dialTestIndicator, name: 'Dial Test Indicator' },
  { img: profileProjector, name: 'Profile Projector' },
  { img: digitalMicrometer, name: 'Digital Micrometer' },
  { img: skyViewer, name: 'Sky Viewer - PC Microscope' },
];

const machines = [
  { name: 'Roundness Tester Machine', diagram: roundnessDiagram, photo: roundnessPhoto },
  { name: 'Hardness Tester Machine', diagram: hardnessDiagram, photo: hardnessPhoto },
  { name: 'Surface Texture Machine', diagram: surfaceDiagram, photo: surfacePhoto },
  { name: 'Keyence Image Dimension Machine', diagram: keyenceDiagram, photo: keyencePhoto },
];

const QualityAssurance = () => (
  <div>
    <Hero title={<>Quality <span className="highlight">Assurance</span></>} subtitle="Advanced QA equipment ensuring every shaft meets the tightest customer specifications." backgroundImage={heroBg} />

    <section className="qa section">
      <div className="container">
        <p className="section-label">QA Instruments</p>
        <h2 className="section-title">Measurement <span className="highlight">Equipment</span></h2>
        <p className="qa__desc">Different QA machines used to identify the quality of the shafts based on customer specification requirements.</p>
        <div className="qa__instruments">
          {instruments.map((inst, i) => (
            <div className="qa__instrument" key={i}>
              <div className="qa__instrument-img"><img src={inst.img} alt={inst.name} /></div>
              <h4>{inst.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="qa-machines section">
      <div className="container">
        <p className="section-label">Testing Machines</p>
        <h2 className="section-title">Advanced <span className="highlight">Testing</span></h2>
        <div className="qa-machines__grid">
          {machines.map((m, i) => (
            <div className="qa-machine" key={i}>
              <h3 className="qa-machine__name">{m.name}</h3>
              <div className="qa-machine__images">
                <img src={m.diagram} alt={`${m.name} output`} />
                <img src={m.photo} alt={m.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default QualityAssurance;
